import { PersistStore, PersistFields } from './Device';
import { get, set } from 'idb-keyval';

const LOCAL_FORAGE_DEVICE_INFO_KEY = 'ActivityManager_deviceInfo';

export const idbKeyvalPersistStore: PersistStore = {
  load: async () => {
    const deviceInfo = (await get(LOCAL_FORAGE_DEVICE_INFO_KEY)) as PersistFields | null | undefined;
    return deviceInfo;
  },
  save: async (deviceInfo) => {
    await set(LOCAL_FORAGE_DEVICE_INFO_KEY, deviceInfo);
  },
};
